import React from 'react';

const Admin = () => {
  return <div>Admin Panel Placeholder</div>;
};

export default Admin;